var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayStore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_71_7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M396.588 400.081L65.9 758.517L55.8344 769.536C49.5766 760.288 45.3594 749.267 44.4078 737.027C44.1359 734.852 44 732.672 44 730.497V69.5297C44 54.7047 48.4891 41.3735 55.8344 30.4875L396.588 400.081Z",
    fill: "#59A6CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.267 238.75L396.587 400.083L55.8344 30.4875C75.15 2.19529 114.598 -9.9094 148.062 9.40623L545.267 238.75Z",
    fill: "#B6D9A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M755.025 401.984C754.481 424.567 742.919 447.147 720.473 460.069L545.267 561.273L396.588 400.081L545.267 238.75L655.452 302.414L720.473 339.955C744.278 353.697 755.842 377.908 755.025 401.984Z",
    fill: "#F0CE89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.861 769.519C75.186 797.825 114.609 809.891 148.011 790.606L545.211 561.281L396.53 400.017L55.861 769.519Z",
    fill: "#B6547C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M753.48 385.074C749.647 367.077 738.662 350.455 720.473 339.955L655.452 302.414L545.267 238.75L148.062 9.40647C114.598 -9.90915 75.15 2.19553 55.8344 30.4877C48.4891 41.3737 44 54.7049 44 69.5299V450.342C101.314 455.208 159.978 457.758 219.705 457.758C294.68 457.758 367.908 453.627 438.952 446.031L396.722 400.228L438.969 446.031C550.231 434.139 655.823 413.36 753.48 385.074Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_71_7"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 800,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStore);
export default __webpack_public_path__ + "static/media/playStore.79c5391349327371e226d4f30fbf139c.svg";
export { ForwardRef as ReactComponent };